import {
  Directive,
  ElementRef,
  Input,
  Renderer2,
  RendererStyleFlags2,
  SimpleChange,
} from '@angular/core';

import { tokenToCssVar } from '@recruitee/utils';

import { SupportedThemes, Theme } from '../../../core/tokens/services/theme.service';

type IconSpecificTokenExtract<T> = Extract<T, `colorIcon${string}Default`>;
type ExtractedIconToken = IconSpecificTokenExtract<keyof Theme>;

export type IconToken = ExtractedIconToken extends never
  ? IconSpecificTokenExtract<keyof typeof SupportedThemes.light>
  : ExtractedIconToken;

@Directive({
  selector: '[iconColor]',
  exportAs: 'iconColor',
  standalone: true,
})
export class IconColorDirective {
  @Input('iconColor') public colorToken: IconToken = <IconToken>'colorIconDefault';

  constructor(public elementRef: ElementRef, private renderer: Renderer2) {}

  public ngOnChanges(changes: SimpleChange): void {
    if ('colorToken' in changes && this.colorToken) this.setColorToken();
  }

  private setColorToken(): void {
    this.renderer.addClass(this.elementRef.nativeElement, 'icon-color-token');
    this.renderer.setStyle(
      this.elementRef.nativeElement,
      '--icon-color-token',
      tokenToCssVar(this.colorToken),
      RendererStyleFlags2.Important + RendererStyleFlags2.DashCase,
    );
  }
}
